import { styled } from "@mui/material/styles";
import Box from "designSystem/components/box/Box";
import Text from "designSystem/components/text/Text";
import React, { FunctionComponent } from "react";

const PREFIX = "ViewSeparator";

const classes = {
	root: `${PREFIX}root`,
};

const StyledBox = styled(Box)(({
	theme,
}) => ({
	[`&.${classes.root}`]: {
		borderBottom: `2px solid ${theme.palette.grey[400]}`,
		paddingBottom: 2,
	},
}));

export interface ViewSeparatorProps {
	/** resource id */
	res: string;

	/** parameters for resource */
	resParams?: Array<number | string>;
}

const ViewSeparator: FunctionComponent<ViewSeparatorProps> = (props) => {
	return (
		<StyledBox className={classes.root}>
			<Text variant="h4" {...props} />
		</StyledBox>
	);
};

export default ViewSeparator;
